// Generated by orval — do not edit manually.
// See: openapi.yaml
import type {
  FrontofficeGetWebRedirect200,
  FrontofficeGetWebRedirectParams,
  FrontofficeWebInterlinkRegionTree200,
  FrontofficeWebSeoArticleAuthorGetByUri200,
  FrontofficeWebSeoArticleAuthorGetByUriParams,
  FrontofficeWebSeoArticleGetByUri200,
  FrontofficeWebSeoArticleGetByUriParams,
  FrontofficeWebSeoArticleTagGetByUri200,
  FrontofficeWebSeoArticleTagGetByUriParams,
  FrontofficeWebSeoCategoryGetByUri200,
  FrontofficeWebSeoCategoryGetByUriParams,
  FrontofficeWebSeoDocumentGetByUri200,
  FrontofficeWebSeoDocumentGetByUriParams,
  FrontofficeWebSeoGetAiTxt200,
  FrontofficeWebSeoGetLlmTxt200,
  FrontofficeWebSeoGetMarkup200,
  FrontofficeWebSeoGetMarkupPathParameters,
  FrontofficeWebSeoGetRobotsTxt200,
  FrontofficeWebSeoRegionGetByUri200,
  FrontofficeWebSeoRegionGetByUriParams
} from './frontofficeAPI.schemas';

import { orvalInstance } from '../../modules/api/orvalInstance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * ### Access:
 *
 * Anonymous and Signed-In customers.
 */
export const frontofficeWebInterlinkRegionTree = (

 options?: SecondParameter<typeof orvalInstance<FrontofficeWebInterlinkRegionTree200>>,) => {
      return orvalInstance<FrontofficeWebInterlinkRegionTree200>(
      {url: `/web/interlink/region`, method: 'GET'
    },
      options);
    }
  /**
 * ### Access:
 *
 * Anonymous and Signed-In customers.
 */
export const frontofficeGetWebRedirect = (
    params: FrontofficeGetWebRedirectParams,
 options?: SecondParameter<typeof orvalInstance<FrontofficeGetWebRedirect200>>,) => {
      return orvalInstance<FrontofficeGetWebRedirect200>(
      {url: `/web/redirect`, method: 'GET',
        params
    },
      options);
    }
  /**
 * ### Access:
 *
 * Unlimited access, no token required.
 */
export const frontofficeWebSeoGetAiTxt = (

 options?: SecondParameter<typeof orvalInstance<FrontofficeWebSeoGetAiTxt200>>,) => {
      return orvalInstance<FrontofficeWebSeoGetAiTxt200>(
      {url: `/web/seo/ai`, method: 'GET'
    },
      options);
    }
  /**
 * ### Access:
 *
 * Anonymous and Signed-In customers.
 */
export const frontofficeWebSeoArticleAuthorGetByUri = (
    params: FrontofficeWebSeoArticleAuthorGetByUriParams,
 options?: SecondParameter<typeof orvalInstance<FrontofficeWebSeoArticleAuthorGetByUri200>>,) => {
      return orvalInstance<FrontofficeWebSeoArticleAuthorGetByUri200>(
      {url: `/web/seo/article-author/get-by-uri`, method: 'GET',
        params
    },
      options);
    }
  /**
 * ### Access:
 *
 * Anonymous and Signed-In customers.
 */
export const frontofficeWebSeoArticleTagGetByUri = (
    params: FrontofficeWebSeoArticleTagGetByUriParams,
 options?: SecondParameter<typeof orvalInstance<FrontofficeWebSeoArticleTagGetByUri200>>,) => {
      return orvalInstance<FrontofficeWebSeoArticleTagGetByUri200>(
      {url: `/web/seo/article-tag/get-by-uri`, method: 'GET',
        params
    },
      options);
    }
  /**
 * ### Access:
 *
 * Anonymous and Signed-In customers.
 */
export const frontofficeWebSeoArticleGetByUri = (
    params: FrontofficeWebSeoArticleGetByUriParams,
 options?: SecondParameter<typeof orvalInstance<FrontofficeWebSeoArticleGetByUri200>>,) => {
      return orvalInstance<FrontofficeWebSeoArticleGetByUri200>(
      {url: `/web/seo/article/get-by-uri`, method: 'GET',
        params
    },
      options);
    }
  /**
 * ### Access:
 *
 * Anonymous and Signed-In customers.
 */
export const frontofficeWebSeoCategoryGetByUri = (
    params: FrontofficeWebSeoCategoryGetByUriParams,
 options?: SecondParameter<typeof orvalInstance<FrontofficeWebSeoCategoryGetByUri200>>,) => {
      return orvalInstance<FrontofficeWebSeoCategoryGetByUri200>(
      {url: `/web/seo/category/get-by-uri`, method: 'GET',
        params
    },
      options);
    }
  /**
 * ### Access:
 *
 * Anonymous and Signed-In customers.
 */
export const frontofficeWebSeoDocumentGetByUri = (
    params: FrontofficeWebSeoDocumentGetByUriParams,
 options?: SecondParameter<typeof orvalInstance<FrontofficeWebSeoDocumentGetByUri200>>,) => {
      return orvalInstance<FrontofficeWebSeoDocumentGetByUri200>(
      {url: `/web/seo/document/get-by-uri`, method: 'GET',
        params
    },
      options);
    }
  /**
 * ### Access:
 *
 * Unlimited access, no token required.
 */
export const frontofficeWebSeoGetLlmTxt = (

 options?: SecondParameter<typeof orvalInstance<FrontofficeWebSeoGetLlmTxt200>>,) => {
      return orvalInstance<FrontofficeWebSeoGetLlmTxt200>(
      {url: `/web/seo/llm`, method: 'GET'
    },
      options);
    }
  /**
 * ### Access:
 *
 * Anonymous and Signed-In customers.
 */
export const frontofficeWebSeoGetMarkup = (
    { offer }: FrontofficeWebSeoGetMarkupPathParameters,
 options?: SecondParameter<typeof orvalInstance<FrontofficeWebSeoGetMarkup200>>,) => {
      return orvalInstance<FrontofficeWebSeoGetMarkup200>(
      {url: `/web/seo/offer/${offer}/markup`, method: 'GET'
    },
      options);
    }
  /**
 * ### Access:
 *
 * Anonymous and Signed-In customers.
 */
export const frontofficeWebSeoRegionGetByUri = (
    params: FrontofficeWebSeoRegionGetByUriParams,
 options?: SecondParameter<typeof orvalInstance<FrontofficeWebSeoRegionGetByUri200>>,) => {
      return orvalInstance<FrontofficeWebSeoRegionGetByUri200>(
      {url: `/web/seo/region/get-by-uri`, method: 'GET',
        params
    },
      options);
    }
  /**
 * ### Access:
 *
 * Unlimited access, no token required.
 */
export const frontofficeWebSeoGetRobotsTxt = (

 options?: SecondParameter<typeof orvalInstance<FrontofficeWebSeoGetRobotsTxt200>>,) => {
      return orvalInstance<FrontofficeWebSeoGetRobotsTxt200>(
      {url: `/web/seo/robots`, method: 'GET'
    },
      options);
    }
  export type FrontofficeWebInterlinkRegionTreeResult = NonNullable<Awaited<ReturnType<typeof frontofficeWebInterlinkRegionTree>>>
export type FrontofficeGetWebRedirectResult = NonNullable<Awaited<ReturnType<typeof frontofficeGetWebRedirect>>>
export type FrontofficeWebSeoGetAiTxtResult = NonNullable<Awaited<ReturnType<typeof frontofficeWebSeoGetAiTxt>>>
export type FrontofficeWebSeoArticleAuthorGetByUriResult = NonNullable<Awaited<ReturnType<typeof frontofficeWebSeoArticleAuthorGetByUri>>>
export type FrontofficeWebSeoArticleTagGetByUriResult = NonNullable<Awaited<ReturnType<typeof frontofficeWebSeoArticleTagGetByUri>>>
export type FrontofficeWebSeoArticleGetByUriResult = NonNullable<Awaited<ReturnType<typeof frontofficeWebSeoArticleGetByUri>>>
export type FrontofficeWebSeoCategoryGetByUriResult = NonNullable<Awaited<ReturnType<typeof frontofficeWebSeoCategoryGetByUri>>>
export type FrontofficeWebSeoDocumentGetByUriResult = NonNullable<Awaited<ReturnType<typeof frontofficeWebSeoDocumentGetByUri>>>
export type FrontofficeWebSeoGetLlmTxtResult = NonNullable<Awaited<ReturnType<typeof frontofficeWebSeoGetLlmTxt>>>
export type FrontofficeWebSeoGetMarkupResult = NonNullable<Awaited<ReturnType<typeof frontofficeWebSeoGetMarkup>>>
export type FrontofficeWebSeoRegionGetByUriResult = NonNullable<Awaited<ReturnType<typeof frontofficeWebSeoRegionGetByUri>>>
export type FrontofficeWebSeoGetRobotsTxtResult = NonNullable<Awaited<ReturnType<typeof frontofficeWebSeoGetRobotsTxt>>>
